import { tr } from "../../i18n";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api } from "../../auth/AuthContext";
import { Badge, statusTone, EmptyState, fmtDate } from "../../components/portal";
export default function Assessments() {
  const {
    lang = "en"
  } = useParams();
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get("/client/assessments").then(r => setItems(r.data)).catch(() => setItems([]));
  }, []);
  return <div className="mx-auto max-w-5xl" data-testid="client-assessments">
      <h1 className="text-2xl font-semibold tracking-tight text-esaia-ink sm:text-3xl">{tr("My Assessments")}</h1>
      <p className="mt-1 text-sm text-esaia-muted">{tr("All ESAIA assessments and ERI results for your organization.")}</p>

      <div className="mt-8">
        {items === null ? <p className="text-sm text-esaia-subtle">{tr("Loading...")}</p> : items.length === 0 ? <EmptyState message={tr("No assessments yet.")} /> : <div className="border border-esaia-line bg-white">
            {items.map(a => <Link key={`${a.kind || "ASS"}-${a.id}`} to={`/${lang}/portal/assessments/${a.kind === "ERI_RESULT" ? `eri-${a.id}` : a.id}`} data-testid={`assessment-row-${a.assessment_id}`} className="group grid grid-cols-1 gap-2 border-b border-esaia-line px-6 py-5 transition-colors last:border-0 hover:bg-esaia-canvas sm:grid-cols-12 sm:items-center">
                <div className="sm:col-span-5">
                  <p className="text-sm font-semibold text-esaia-ink group-hover:text-esaia-blue">{tr(a.service_label)}</p>
                  <p className="mt-0.5 font-mono text-[11px] text-esaia-subtle">
                    {a.assessment_id}
                    {a.kind === "ERI_RESULT" && a.total_score !== undefined && ` · Score ${a.total_score}/100`}
                  </p>
                </div>
                <div className="sm:col-span-3">
                  <Badge tone={statusTone(a.status)}>{tr(a.status)}</Badge>
                </div>
                <div className="text-xs text-esaia-subtle sm:col-span-3">{tr("Start:")}{" "}{fmtDate(a.start_date)}
                  {a.completion_date ? ` · Completed: ${fmtDate(a.completion_date)}` : ""}
                </div>
                <div className="sm:col-span-1 sm:text-right">
                  <ArrowRight size={16} className="inline text-esaia-blue transition-transform group-hover:translate-x-1" />
                </div>
              </Link>)}
          </div>}
      </div>
    </div>;
}
